import { Badge, Col, Row } from "react-bootstrap";
import {
  formatRallyDate,
  formatRallyDateRange,
  formatRallyStatus,
} from "../../utils/rally.utils";

const statusVariant = {
  active: "success",
  upcoming: "info",
  completed: "secondary",
  cancelled: "danger",
};

const DetailItem = ({ label, children }) => (
  <div className="mb-3">
    <div className="text-muted small mb-1">{label}</div>
    <div>{children ?? "-"}</div>
  </div>
);

const RallyInfoSection = ({ rally }) => {
  return (
    <div className="mb-4">
      <h5 className="mb-3">Rally Information</h5>
      <Row>
        <Col md={6}>
          <DetailItem label="Name">{rally?.name || "-"}</DetailItem>
        </Col>
        <Col md={3}>
          <DetailItem label="Edition">
            {rally?.edition_number ?? "-"}
          </DetailItem>
        </Col>
        <Col md={3}>
          <DetailItem label="Status">
            <Badge bg={statusVariant[rally?.status] || "secondary"}>
              {formatRallyStatus(rally?.status)}
            </Badge>
          </DetailItem>
        </Col>
        <Col md={6}>
          <DetailItem label="Location">{rally?.location || "-"}</DetailItem>
        </Col>
        <Col md={6}>
          <DetailItem label="Organiser">{rally?.organiser || "-"}</DetailItem>
        </Col>
        <Col md={4}>
          <DetailItem label="Event Dates">
            {formatRallyDateRange(rally?.date, rally?.end_date)}
          </DetailItem>
        </Col>
        <Col md={4}>
          <DetailItem label="Rally Start Date">
            {formatRallyDate(rally?.rally_start_date)}
          </DetailItem>
        </Col>
        <Col md={4}>
          <DetailItem label="Featured">
            {rally?.is_featured ? "Yes" : "No"}
          </DetailItem>
        </Col>
        <Col md={6}>
          <DetailItem label="Registration Start">
            {formatRallyDate(rally?.registration_start_date)}
          </DetailItem>
        </Col>
        <Col md={6}>
          <DetailItem label="Registration End">
            {formatRallyDate(rally?.registration_end_date)}
          </DetailItem>
        </Col>
        <Col md={12}>
          <DetailItem label="Description">
            {rally?.description || "-"}
          </DetailItem>
        </Col>
      </Row>
    </div>
  );
};

export default RallyInfoSection;
